import { Component, OnInit, ViewChild } from '@angular/core';

import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { faSpinner, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { LoginService } from '@tech-services/login.service';
import { Router } from '@angular/router';
import { CommonService } from '@tech-services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@tech-environments/environment';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MatButton } from '@angular/material/button';
import { AppConfig } from '@tech-utils/app-config.service';
import { TechDialogsService } from '../../shared/tech-dialogs.service';

@Component({
  selector: 'tech-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss'],
})
export class RecoverPasswordComponent implements OnInit {
  @ViewChild('btnSend', { static: true }) btnSend: MatButton;
  public domain: string = localStorage.getItem('Domain');
  public customTheme = localStorage.getItem('ThemeImg');

  public form: UntypedFormGroup;
  public faSpinner: IconDefinition = null;
  public token01 = '';
  public token02 = '';
  public logoUrl =
    './assets/img/' +
    localStorage.getItem('ThemeImg') +
    '/WealthRules-265px.png';
  private unsubscribe$ = new Subject<void>();
  public backEffect: boolean = JSON.parse(AppConfig.settings.backgroundEffect);
  public img = 'FondoLogin.jpg';

  constructor(
    private fb: UntypedFormBuilder,
    private loginService: LoginService,
    private router: Router,
    private commonService: CommonService,
    private translate: TranslateService,
    private dialogService: TechDialogsService
  ) {
    this.form = this.fb.group({
      user: ['', [Validators.required]],
    });
  }

  ngOnInit() {
    this.randomBackgroundImage();
    this.translate.get('k000627').subscribe((text: string) => {
      this.token01 = text;
    });
    this.translate.get('Si el identificador ingresado está registrado, te hemos enviado un enlace para restablecer tu contraseña. Por favor, revisa tu bandeja de entrada y sigue las instrucciones.').subscribe((text: string) => {
      this.token02 = text;
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  onSendEmail() {
    this.faSpinner = faSpinner;

    this.commonService
      .getAppSetting()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        localStorage.setItem('Language', data.language);
        localStorage.setItem('Domain', data.domain);
      });

    const form = this.form.value;
    this.loginService
      .sendResetPassMailClient(
        form.user,
        localStorage.getItem('Domain'),
        localStorage.getItem('Language'),
        form.user
      )
      .subscribe(
        (data) => {
          this.form.reset();
          this.dialogService.openModalDialog(
            '',
            this.token01,
            this.token02,
            ''
          );
          this.faSpinner = null;
        },
        (err) => {
          this.dialogService.openModalDialog(
            '',
            this.token01,
            this.token02, 
            ''
          );
          this.form.reset();
          this.faSpinner = null;
        }
      );
  }

  public randomBackgroundImage() {
    let numberImages = 12;
    let includeCero = false;
    let min = includeCero ? 0 : 1;
    let number = Math.floor(Math.random() * (numberImages - min)) + min;
    this.img =
      number < 10
        ? 'FondoLogin_0' + number + '.jpg'
        : 'FondoLogin_' + number + '.jpg';
  }
}
